import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { findLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";

findLocationModalStyles.currentlySelectedHeaderText = mergeToNew(findLocationModalStyles.currentlySelectedHeaderText, {
    color: "text.accent",
});
